import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

import { Loader, Form, Field } from '@smartplatform/ui';
import { useGetRecord } from 'root/admin/components/hooks';

import { Title } from 'root/admin/components';
import store from 'root/admin/store';

// TagsEdit

const TagsEdit = ({ model, match, rootPath, tabName, modelName }) => {
	const { id } = match.params;
	const record = useGetRecord({ model, id, tabName });

	if (!record) {
		return <Loader />;
	}

	return (
		<div>
			<Title record={record} name={modelName} />
			<Form record={record} rootPath={rootPath}>
				<Field property="name" label="Название категории" />
			</Form>
		</div>
	);
};

export default withRouter(TagsEdit);
// export default TagsEdit;
